<template>
  <div @click="showControls" class="annotation annotation-highlight" :style="getStyle"></div>
</template>

<script>
export default {
  name: 'annotation-highlight',

  props: [
    'index',
    'width',
    'height'
  ],

  computed: {
    getStyle: function () {
      return 'width:' + this.width + 'px;height:' + this.height + 'px;'
    }
  },

  methods: {
    showControls () {
      const elPos = this.$el.getBoundingClientRect()
      this.$bus.emit('showAnnotationControls', {
        index: this.index,
        type: 'textarea',
        x: elPos.left,
        y: elPos.top + elPos.height
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .annotation-highlight {
    background-color: rgba(255, 255, 0, 0.7)
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/annotations/AnnotationHighlight.vue